let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("12K5T")).then(() => parcelRequire('h9o9V'));